module.exports = __webpack_public_path__ + "img/edit-icon.be6b97bd.svg";